import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { MESSAGING_PILLARS } from '../../../content/enterpriseMessaging';

/**
 * Reusable positioning pillars (the repeatable "why MyOrgLab" points).
 * Pulls from MESSAGING_PILLARS; `limit` trims how many render.
 */
export default function MessagingPillars({ limit, className = '', pillars }) {
  const items = (pillars || MESSAGING_PILLARS).slice(0, limit ?? undefined);

  return (
    <ul className={`space-y-3 ${className}`}>
      {items.map((p) => (
        <li key={p.title} className="flex items-start gap-3">
          <CheckCircleIcon
            className="h-5 w-5 flex-shrink-0 text-brand-500 mt-0.5"
            aria-hidden="true"
          />
          <div>
            <p className="text-sm font-semibold text-ink-900">{p.title}</p>
            {p.desc && (
              <p className="mt-0.5 text-sm text-ink-500 leading-relaxed">{p.desc}</p>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
